module.exports = __webpack_public_path__ + "static/media/Subcondral.b25d541d.png";